<template>
    <div class="bart-bg">
        <div class="game-bart" >
            <div class="menu-left">                
                <span class="item">BALLOON: {{index + 1 + ' van de ' + settings.BALLOONS.length}}</span>
                <!--<span class="item">HUIDIG: €{{formatTempCash}}</span>-->
                <span class="item">VORIGE: €{{formatPrevCash}}</span>
                <span class="item">BEHAALD: €{{formatPermCash}}</span>
                <span class="item" style="color: #f0f; text-transform: none;">Vergeet niet op cash te klikken!</span> 
            </div>
            <div class="game-center">
                <div class="game-visuals">
                    <img class="img-title" src="./images/games/bart/title.png"/>
                    <img class="img-push" @mousedown="buttonPumpPress" @mouseup="buttonPumpRelease" src="./images/games/bart/push-indicator.png" :class="{'highlight': cashDisabled}" />
                    <div ref="bartBalloon" id="bart-balloon" :class="{'exploded': exploded}" :style="{'--pumps': pumps}"><div class="inset"><span>€{{formatTempCash}}</span></div></div>
                    <img v-show="!pumping" @mousedown.prevent="buttonPumpPress" @mouseup.prevent="buttonPumpRelease" class="img-pump" src="./images/games/bart/pump-uncompressed.png" />
                    <img v-show="pumping" @mousedown.prevent="buttonPumpPress" @mouseup.prevent="buttonPumpRelease" class="img-pump" src="./images/games/bart/pump-compressed.png" />
                    <img class="img-cash" @click.prevent="buttonCashClick" src="./images/games/bart/cash-button.png" :class="{'disabled': cashDisabled}"/>
                </div>
            </div>
        </div>
        <div v-show="finished" class="continue-button-overlay">
            <span @click.prevent="$emit('next')" class="continue-button">Verder ></span>
        </div>
    </div>
</template>

<script>
import Backend from '../../../services/Backend';
import Audio from '../../../services/Audio';

export default {
    'props': {
        data: {}
    },
    'data': function() {
        return {
            settings: {
                CASH_PER_PUMP: 0.1,
                BALLOONS: [
                    8,   5,   4,   4,   7,   3,   6,   7,   6,   2,
                    6,  23,  12,   6,  14,  29,  24,  19,  21,   5, 
                    32,  94,  92,  10,  53,  50,  65, 125,  73, 102
                ],
            },
            results: {
                totalBalloons: 0,
                totalExplodedBalloons: 0,
                averagePumpsNotExplodedBalloons: 0,
            },
            cash: 0,
            prevCash: 0,
            pumps: 0,
            index: 0,
            exploded: false,
            finished: false,
            pumping: false,
            pumpDisabled: false,
            cashDisabled: true,
        };
    },
    'watch': {
        data: {
            handler() {
            }
        }
    },
    'computed': {
        'formatTempCash': function() {
            return (this.pumps * this.settings.CASH_PER_PUMP).toFixed(2).replace('.', ',');
        },
        'formatPrevCash': function() {
            return this.prevCash.toFixed(2).replace('.', ',');
        },
        'formatPermCash': function() {
            return this.cash.toFixed(2).replace('.', ',');
        }
    },
    'methods': {
        'buttonPumpPress': function() {
            if(this.finished || this.exploded || this.pumpDisabled) {
                return;
            }

            if (this.pumps < this.settings.BALLOONS[this.index]) {
                this.pumps += 1;

                this.cashDisabled = false;
                Audio.playSFX('pump-balloon');
            } else {
                Audio.playSFX('pump-balloon-pop');
                this.reset(true);
            }

            this.pumping = true;
        },
        'buttonPumpRelease': function() {
            this.pumping = false;
        },
        'buttonCashClick': function() {
            if (this.finished || this.cashDisabled) {
                return;
            }

            Audio.playSFX('cash');
            this.reset(false);
        },
        'reset': function(exploded) {
            this.exploded = exploded;
            if (exploded) {
                this.results.totalBalloons += 1;
                this.results.totalExplodedBalloons += 1;
            } else {
                this.results.totalBalloons += 1;
                this.results.averagePumpsNotExplodedBalloons -=
                    (this.results.averagePumpsNotExplodedBalloons - this.pumps) / 
                    (this.results.totalBalloons - this.results.totalExplodedBalloons);
            }

            this.pumpDisabled = true;
            this.cashDisabled = true;

            setTimeout(() => {
                this.prevCash = exploded ? 0 : this.pumps * this.settings.CASH_PER_PUMP;
                
                this.cash += this.prevCash;
                this.pumps = 0;

                if (this.index < this.settings.BALLOONS.length - 1) {
                    this.next();
                } else {
                    this.finish();
                }
            }, exploded ? 1000 : 100);
        },
        'next': function() {
            this.index += 1;
            this.pumpDisabled = false;
            this.exploded = false;
        },
        'finish': function() {
            this.finished = true;
            this.prevCash = 0;

            this.$emit('complete');
            this.$emit('answer', { 
                questionId: this.data[0].question.id, 
                answerParts: [ 
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalBalloons').id, answerPart: this.results.totalBalloons + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'totalExplodedBalloons').id, answerPart: this.results.totalExplodedBalloons + '' },
                    { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'averagePumpsNotExplodedBalloons').id, answerPart: this.results.averagePumpsNotExplodedBalloons + '' },
                ] 
            });

            console.table(this.results);
        },
        'enableCashButton': function(enabled) {
            this.cashDisabled = !enabled;
        },
        'formatCash': function(cash) {
            return cash.toFixed(2).replace('.', ',');
        },
    }
}
</script>